import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "h-100 d-flex flex-column" }
const _hoisted_2 = {
  id: "Page_Title",
  class: "col-12 material-card"
}
const _hoisted_3 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_4 = {
  id: "Page_Row",
  class: "row g-0"
}
const _hoisted_5 = {
  class: "col me-0 me-md-3",
  id: "Page__Aside",
  ref: "sideNav"
}
const _hoisted_6 = {
  class: "collapse-control p-2",
  "data-bs-toggle": "collapse",
  href: "#Page__SideNav",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "Page__SideNav"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars me-2" }, null, -1 /* HOISTED */)
const _hoisted_8 = {
  class: "collapse",
  id: "Page__SideNav"
}
const _hoisted_9 = {
  class: "nav-section",
  id: "Page__Filter"
}
const _hoisted_10 = { class: "buttons-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("header", _hoisted_2, [
      (_ctx.pageTitle)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_ctx.pageTitle), 1 /* TEXT */))
        : _renderSlot(_ctx.$slots, "title", { key: 1 })
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.hasTitle]
    ]),
    _createCommentVNode(" Start of page layout "),
    _createElementVNode("div", {
      class: _normalizeClass(["container-fluid p-0 flex-grow-1 overflow-auto", _ctx.isFullPage ? 'is-full-page' : '']),
      id: "Page"
    }, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("aside", _hoisted_5, [
          _createElementVNode("a", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.activeRouteName), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("section", _hoisted_9, [
              _renderSlot(_ctx.$slots, "filter")
            ]),
            _createElementVNode("section", {
              class: _normalizeClass(["nav-section", _ctx.hasButtons ? 'has-buttons' : '']),
              id: "Page__Navigation"
            }, [
              _renderSlot(_ctx.$slots, "navigation")
            ], 2 /* CLASS */)
          ])
        ], 512 /* NEED_PATCH */), [
          [_vShow, _ctx.hasSideNav]
        ]),
        _createElementVNode("main", {
          class: _normalizeClass(["position-relative col-12", `${_ctx.contentClass} ${_ctx.hasSideNav ? 'has-side-nav col-lg-10' : ''} ${
                        _ctx.hasPageScroll ? 'page-scroll-control' : _ctx.hasListScroll ? 'list-scroll-control' : ''
                    }`]),
          id: "Page__Content"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(`content-wrapper ${_ctx.hasButtons ? 'has-buttons' : ''}`)
          }, [
            _renderSlot(_ctx.$slots, "content")
          ], 2 /* CLASS */),
          _withDirectives(_createElementVNode("div", _hoisted_10, [
            _renderSlot(_ctx.$slots, "buttons")
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.hasButtons]
          ])
        ], 2 /* CLASS */)
      ])
    ], 2 /* CLASS */)
  ]))
}